import XLSX from 'xlsx';

export const readXlsx = (
    evt: any,
    callback: any,
): {
    file: File | null;
    extension: string;
} => {
    const file = evt?.target?.files?.[0];
    const extensionArr = file?.name?.split('.');
    const extension = extensionArr ? extensionArr[extensionArr.length - 1] : null;
    const reader = new FileReader();
    reader.onload = (evt) => {
        // evt = on_file_select event
        /* Parse data */
        const bstr = evt?.target?.result;
        const wb = XLSX.read(bstr, {type: 'binary'});
        /* Get first worksheet */
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        /* Convert array of arrays */
        const data = XLSX.utils.sheet_to_json(ws, {header: 'A', range: 1});
        /* Update state */
        callback(data, file);
        // fileChanged(f);
    };
    file && reader.readAsBinaryString(file);

    return {
        file,
        extension,
    };
};
